export default {
  sui: {
    loading: {
      text: 'Загрузка'
    },
    form: {
      more: 'Ещё',
      zhankai: 'Развернуть',
      shouqi: 'Свернуть',
      query: 'Поиск',
      reset: 'Сбросить',
      add: 'Добавить',
      update: 'Обновить',
      delete: 'Удалить',
      required: 'обязательно',
      export: {
        export: 'Экспорт',
        selectFormat: 'выберите формат',
        selectedRow: 'выбрано {key} строк',
        selectedTotal: 'всего {key} строк, экспорт',
        line: 'строка'
      },
      please: {
        input: 'введите ',
        select: 'выберите '
      },
      time: {
        start: 'время начала',
        end: 'время окончания',
        to: 'до'
      },
      date: {
        start: 'дата начала',
        end: 'дата окончания'
      },
      upload: {
        triggerText: 'загрузить'
      },
      expand: 'Развернуть',
      multiple: 'Множественный',
      cols_hide: 'Настройки заголовка'
    },
    table: {
      handle: 'Действия',
      sum: 'Сумма',
      index: 'Индекс',
      zanwushuju: 'нет данных',
      queding: 'Ок',
      quxiao: 'Отмена',
      lie: 'Столбец',
      yiyincang: 'Скрыто',
      gong: 'Всего'
    },
    tableEdit: {
      tip1: 'Данные все еще в режиме редактирования и не могут быть сохранены!',
      tip2: 'Вы уверены, что хотите удалить данные?',
      baocun: 'Сохранить',
      chongzhi: 'Сбросить',
      xinzeng: 'добавить',
      guanbituozhuai: 'закрыть перетаскивание',
      kaiqituozhuai: 'открыть перетаскивание',
      caozuo: 'Действия',
      queren: 'Ок',
      bianji: 'Редактировать',
      shanchu: 'Удалить',
      tishi: 'подсказки'
    },
    list: {
      yi_xuan_ze: 'выбрано',
      tiao: 'элементов',
      gong: 'всего',
      mei_you_geng_duo: 'больше нет',
      zan_wu_shu_ju: 'Данные еще не выбраны'
    },
    bond: {
      zheng_quan_dai_ma: 'код облигации',
      zheng_quan_ming_cheng: 'название облигации',
      zan_wu_shu_ju: 'нет данных',
      qu_xiao_qing_qiu: 'запрос был отменен'
    },
    dialog: {
      ok: 'Ок',
      cancel: 'Отмена'
    },
    page: {
      add: {
        success: 'добавление [{key}] успешно'
      },
      delete: {
        title: '{key}-удаление',
        confirm: 'подтвердить удаление [{key}]?',
        success: 'удаление [{key}] успешно'
      },
      update: {
        success: 'обновление [{key}] успешно',
        noChange: 'данные не изменились, не сохранены'
      }
    },
    tablePage: {
      export: {
        tip1: 'пожалуйста, введите правильный номер строки',
        tip2: 'тип экспорта',
        tip3: 'выберите',
        tip4: 'экспорт как',
        tip5: 'пожалуйста, выберите тип файла для экспорта',
        lie: 'столбец',
        hang: 'строка',
        shi: 'да',
        fou: 'нет',
        daochu: 'Экспорт',
        wancheng: 'Подтвердить',
        quxiao: 'Отмена',
        gong: 'Всего',
        type1: 'последовательный экспорт',
        type2: 'экспорт с ручным выбором',
        daochu_geshi: 'тип файла для экспорта'
      }
    },
    editlist: {
      caozuo: 'Действия',
      shanchu: 'Удалить',
      xinzeng: 'Добавить'
    },
    upload: {
      tip1: 'нажмите клавишу удаления для удаления'
    },
    uploadPro: {
      tip1: 'Соединение Websocket потеряно, попытка переподключения',
      tip2: 'соединение прервано'
    },
    select: {
      jiazaizhong: 'загрузка',
      wupipeishuju: 'нет соответствующих данных',
      wushuju: 'нет данных',
      quanxuan: 'выбрать все',
      fanxuan: 'инвертировать'
    },
    transfer: {
      tip1: 'поиск',
      liebiao1: 'Список 1',
      liebiao2: 'Список 2'
    },
    treeGrid: {
      caozuolan: 'Действия'
    },
    empty: {
      zanwuneirong: 'нет данных'
    },
    valid: {
      char: 'символ',
      len1: 'пожалуйста, введите {p1} ',
      len2: 'пожалуйста, введите от {p1} до {p2} ',
      num: 'цифровой символ',
      pInt: 'положительное целое число',
      npInt: 'неположительное целое число',
      nInt: 'отрицательное целое число',
      nNInt: 'неотрицательное целое число',
      int: 'целое число',
      pFNum: 'положительное число с плавающей точкой',
      nFNum: 'отрицательное число с плавающей точкой',
      num_: 'цифровой символ(-,_)',
      en: 'английский символ',
      en_: 'английский символ(-,_)',
      ch: 'китайский символ',
      ch_: 'китайский символ(-,_)',
      nch: 'некитайский символ',
      numEn: 'цифра или английский символ',
      numEn_: 'цифра или английский символ(-,_)',
      chEnNum: 'цифра, английский или китайский символ',
      chEnNum_: 'цифра, английский или китайский символ(-,_)',
      phone: 'номер телефона',
      email: 'email',
      idcard: 'ID карта',
      url: 'URL',
      reg: 'пожалуйста, введите правильный ',
      version: 'тег версии',
      uri: 'uri',
      datasource: 'источник данных',
      intRegion: 'целое число от {p1} до {p2}',
      floatRegion: 'число с плавающей точкой от {p1} до {p2}'
    },
    timerange: {
      jue_dui_shi_jian_fan_wei: 'Абсолютный временной диапазон',
      xiang_dui_shi_jian_fan_wei: 'Относительный временной диапазон',
      kai_shi_shi_jian: 'Время начала',
      jie_su_shi_jian: 'Время окончания',
      zui_jin_wu_fen_zhong: 'Последние 5 минут',
      zui_jin_shi_wu_fen_zhong: 'Последние 15 минут',
      zui_jin_san_shi_fen_zhong: 'Последние 30 минут',
      zui_jin_yi_xiao_shi: 'Последний час',
      zui_jin_san_xiao_shi: 'Последние 3 часа',
      zui_jin_liu_xiao_shi: 'Последние 6 часов',
      zui_jin_shi_er_xiao_shi: 'Последние 12 часов',
      zui_jin_er_shi_si_xiao_shi: 'Последние 24 часа',
      zui_jin_liang_tian: 'Последние 2 дня',
      zui_jin_qi_tian: 'Последние 7 дней',
      zui_jin_san_shi_tian: 'Последние 30 дней'
    },
    bookmark: {
      biao_ti: 'закладка',
      xin_zeng_shu_qian: 'добавить закладку',
      ming_cheng: 'имя',
      fu_gai: 'перезаписать',
      chong_ming_ming: 'переименовать',
      shan_chu: 'удалить',
      ming_cheng_xiu_gai_cheng_gong: 'Имя успешно изменено',
      xin_zeng: 'добавить',
      shan_chu_ti_shi: 'подтвердить удаление [{name}]?',
      shan_chu_cheng_gong: 'успешно удалено',
      xin_zeng_cheng_gong: 'Закладка успешно добавлена!',
      tian_jia_ji_lu: 'добавить в историю',
      gong: 'всего',
      tiao: 'элементов',
      bao_cun: 'сохранить',
      qing_wan_cheng_zheng_zai_tian_jia_xiang: 'Пожалуйста, подтвердите, что запись добавляется'
    },
    messageBox: {
      qing_shuru_yanzhengma: 'Пожалуйста, введите код проверки',
      yanzhengma_bu_zhengque: 'Неверный код проверки'
    },
    jsonEditor: {
      fuzhi: 'копировать'
    },
    cron: {
      second: 'секунда',
      minute: 'минута',
      hour: 'час',
      day: 'день',
      month: 'месяц',
      week: 'неделя',
      year: 'год',
      cron_biaodashi_ziduan: 'Поле выражения Cron',
      hanhua_fanyi: 'Перевод на русский',
      chongzhi: 'Сбросить',
      single: 'каждый ',
      mei_nian: 'каждый год',
      mei_yue: 'каждый месяц',
      mei_ri: 'каждый день',
      mei_tian: 'каждый день',
      mei_shi: 'каждый час',
      xiaoshi: 'час',
      mei_fenzhong: 'каждую минуту',
      mei_miao: 'каждую секунду',
      mei_zhou: 'каждую неделю',
      cong: 'с',
      yue_qi_mei_ge: 'каждый месяц',
      ri_qi_mei_ge: 'каждый день',
      shi_qi_mei_ge: 'каждый час',
      fenzhong_qi_mei_ge: 'каждую минуту',
      miao_qi_mei_ge: 'каждую секунду',
      zuihou_yitian: 'последний день',
      zhi: 'до',
      cong_zhou: 'с недели',
      zhi_zhou: 'до недели',
      qi_meige: 'каждый',
      tian_zhixingyici: ' раз в день',
      xiaoshi_zhixingyici: ' раз в час',
      yue_zhixingyici: ' раз в месяц',
      zhixingyici: ' выполнить один раз',
      ben_yue_di: 'конец этого месяца',
      ben_yue: 'этот месяц',
      xinqi: 'неделя',
      benyue_zuihou_yige_xingqi: 'Последняя неделя месяца',
      buzhiding: 'Не указано',
      zhouqi_cong: 'Цикл с',
      xunhuan_cong: 'Цикл с',
      tip1: 'каждый день',
      tip2: 'ближайший рабочий день',
      tip3: 'начать, каждый час ',
      tip4: 'начать, каждый месяц',
      tip5: 'день недели',
      benyue_zuihou_yitian: 'Последний день месяца',
      zhiding: 'Указать',
      kaishi: 'начать',
      kaishi_mei: 'начать каждый',
      benyue: 'этот месяц',
      mei: 'каждый ',
      zhixing: 'выполнить',
      zhouqi: 'Цикл',
      di: 'Нет',
      mess1: 'Дата и неделя не могут быть одновременно "не указаны"',
      mess2: 'Один из дней и недель должен быть "не указан"',
      zhouri: 'Воскресенье',
      zhouyi: 'Понедельник',
      zhouer: 'Вторник',
      zhousan: 'Среда',
      zhousi: 'Четверг',
      zhouwu: 'Пятница',
      zhouliu: 'Суббота'
    },
    treeGraph: {
      fangda: 'Увеличить',
      suoxiao: 'Уменьшить',
      shuaxin: 'Обновить'
    }
  }
} 


// WEBPACK FOOTER //
// ./src/components/SimbartUI/lang/ru-RU.js